import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './DistrictInfoScreen';
import DistrictInfo from './DistrictInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getDistrict, getFiles } from 'src/store/actions/district-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        district: state.districts.current,
        files: state.districts.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getDistrict(id)),
        getFiles: (id) => dispatch(getFiles(id)),
    };
}

const DistrictInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(DistrictInfo);

export default DistrictInfoScreen;
